import React from "react";
import { Sparkles } from "lucide-react";

/** Coach dashboard note shown while Free Early Access is on (replaces the trial countdown). */
export default function EarlyAccessNote() {
  return (
    <div data-testid="early-access-note" className="rounded-xl border border-brand-100 bg-gradient-to-br from-brand-50 to-white p-4">
      <div className="flex items-center gap-3">
        <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-white">
          <Sparkles className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-ink-900">Free during Early Access</p>
          <p className="text-xs text-ink-500">
            No credit card required. We&apos;ll notify you before paid subscriptions begin — you&apos;ll never be charged automatically.
          </p>
        </div>
      </div>
    </div>
  );
}
